import { createClient } from '@supabase/supabase-js';
// TODO: re-introduce typed client via `supabase gen types typescript` once we
// add a CI step. Hand-written `Database` shape doesn't match supabase-js v2's
// strict expectations (everything collapses to `never`). Untyped client keeps
// the build green; row types are still enforced where we import them explicitly.

// Singleton Supabase client. Reads VITE_SUPABASE_URL + VITE_SUPABASE_ANON_KEY
// from the environment (see .env.example). Errors out hard if missing so dev
// notices immediately instead of getting silent network failures.

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  // Loud error in dev. In production a missing env var means the build is
  // broken / fail closed rather than try to limp along.
  throw new Error(
    '[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy .env.example to .env.local and fill in.',
  );
}

export const supabase = createClient(url, key, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // magic-link callback parsing on /auth/callback
    storage: window.localStorage,
    storageKey: 'tapes-backoffice-auth',
  },
});

export const PUBLIC_BASE_URL = import.meta.env.VITE_PUBLIC_BASE_URL ?? window.location.origin;

// CF Images account hash (public). Used by cfImageUrl() to build poster URLs.
// Same value the iOS client embeds. Empty string falls back to a placeholder.
export const CF_IMAGES_ACCOUNT_HASH = import.meta.env.VITE_CF_IMAGES_ACCOUNT_HASH ?? '';

// CF Stream customer subdomain code. Used by the PosterPlayer iframe URL.
// Extracted from the existing delivery URLs (customer-<CODE>.cloudflarestream.com).
export const CF_STREAM_CUSTOMER_CODE = import.meta.env.VITE_CF_STREAM_CUSTOMER_CODE ?? '';

// Admin worker URL. Used for direct uploads + cache purge. Empty disables
// those flows (the UI falls back to a "configure admin worker" hint).
export const ADMIN_API_URL = (import.meta.env.VITE_ADMIN_API_URL ?? '').replace(/\/$/, '');

// Public feed worker URL (tapes-feed-mixtapes). Used by the /preview
// route to fetch the exact JSON iOS sees. No auth needed / it's the
// public endpoint the apps consume.
export const FEED_WORKER_URL = (
  import.meta.env.VITE_FEED_WORKER_URL ?? 'https://tapes-feed-mixtapes.tapes-tv.workers.dev'
).replace(/\/$/, '');
